import { PhoneOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { getIconSizeClass, type ButtonSize } from '../utils';

interface EndCallButtonProps {
  onEndCall: () => void;
  size?: ButtonSize;
  className?: string;
}

export function EndCallButton({
  onEndCall,
  size = 'default',
  className,
}: EndCallButtonProps) {
  const { t } = useTranslation();
  const iconSize = getIconSizeClass(size);

  return (
    <Button
      variant="destructive"
      size={size === 'sm' ? 'icon-sm' : size === 'lg' ? 'icon-lg' : 'icon'}
      onClick={onEndCall}
      className={cn('min-h-[44px] min-w-[44px]', className)}
      title={t('videoSession.actions.endCall', 'End call')}
      aria-label={t('videoSession.actions.endVideoCall', 'End video call')}
    >
      <PhoneOff className={iconSize} aria-hidden="true" />
    </Button>
  );
}
